import { render } from "./SelectTimeSlot.vue?vue&type=template&id=2d59791d&scoped=true"
import script from "./SelectTimeSlot.vue?vue&type=script&lang=js"
export * from "./SelectTimeSlot.vue?vue&type=script&lang=js"

import "./SelectTimeSlot.vue?vue&type=style&index=0&id=2d59791d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d59791d"

export default script